import { Info } from "lucide-react";
import { useState } from "react";

export function FieldInput({ id, label, unit, value, onChange, placeholder, type = "number", step, help, badge, testId, min, max }) {
  const [showHelp, setShowHelp] = useState(false);
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <label htmlFor={id} className="font-mono text-[11px] tracking-[0.15em] uppercase text-white/70 font-semibold">
          {label}
        </label>
        <div className="flex items-center gap-2">
          {badge && (
            <span className="font-mono text-[10px] tracking-wide bg-[#F26522] text-black px-2 py-0.5 font-bold">{badge}</span>
          )}
          {help && (
            <button
              type="button"
              onClick={() => setShowHelp(s => !s)}
              className="text-white/50 hover:text-[#F26522] transition-colors"
              data-testid={`${testId}-help`}
              aria-label="help"
            >
              <Info className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
      <div className="relative">
        <input
          id={id}
          data-testid={testId}
          type={type}
          step={step}
          min={min}
          max={max}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full h-16 px-4 pr-20 border-2 border-white/15 bg-[#111111] text-xl font-mono font-medium text-white focus:border-[#F26522] focus:bg-black transition-colors placeholder:text-white/25"
        />
        {unit && (
          <span className="absolute right-4 top-1/2 -translate-y-1/2 font-mono text-xs tracking-wide uppercase text-white/40 pointer-events-none">
            {unit}
          </span>
        )}
      </div>
      {help && showHelp && (
        <div className="text-xs text-white/80 bg-[#1A1A1A] border-l-4 border-[#F26522] p-3" data-testid={`${testId}-help-text`}>
          {help}
        </div>
      )}
    </div>
  );
}
